import React from 'react';
import { MessageDescriptor, useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { CatalogItem } from '../../../../redux/api/fymAPI.types';
import { SongFactRow } from './SongFactRow';
import { LyricsFact, lyricsFactOf, lyricsTarget, SongPageTarget } from './songFieldFacts';
import { catalogSongFieldMessages } from './catalogSongFieldMessages';

const STATE_MESSAGES: Record<LyricsFact, MessageDescriptor> = {
  none: catalogSongFieldMessages.noLyrics,
  plain: catalogSongFieldMessages.lyricsPlain,
  syncing: catalogSongFieldMessages.lyricsSyncing,
  synced: catalogSongFieldMessages.lyricsTimed,
  failed: catalogSongFieldMessages.lyricsFailed,
};

interface SongLyricsFactProps {
  item: CatalogItem;
  onOpen: (target: SongPageTarget) => void;
}

/**
 * The lyric state of the song. No lyrics: "Add the lyrics in Catalog" opens the Text view of the
 * Lyrics section. A failed sync: "Fix the times in Catalog" opens the times.
 */
const SongLyricsFactComponent: React.FC<SongLyricsFactProps> = ({ item, onOpen }) => {
  const intl = useIntl();
  const fact = lyricsFactOf(item);
  const target = lyricsTarget(fact);
  const action =
    target === null
      ? undefined
      : {
          label: intl.formatMessage(
            fact === 'failed' ? catalogSongFieldMessages.fixTimes : catalogSongFieldMessages.addLyrics
          ),
          onClick: () => onOpen(target),
        };

  return (
    <SongFactRow
      label={intl.formatMessage(catalogSongFieldMessages.lyricsLabel)}
      text={intl.formatMessage(STATE_MESSAGES[fact])}
      isProblem={fact === 'failed'}
      action={action}
      testId="song-field-lyrics"
    />
  );
};

export const SongLyricsFact = TypedMemo(SongLyricsFactComponent);
